import { SystemCode } from '@/api'

export interface ForwardingRequestCheckRequest {
  userId: string
  bibliographyId?: number
  collectionId?: number
  collectionNo?: string
  reserveMethod: string
  reserveSpecifyBranch: SystemCode[]
  specifyCollectionId?: number
  specifyCollectionNo?: string
  reserveRegistrationBranchCode: SystemCode
}

export function ForwardingRequestCheckRequestToJSON(
  value: ForwardingRequestCheckRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    bibliography_id:
      value.bibliographyId !== undefined ? value.bibliographyId : undefined,
    collection_id:
      value.collectionId !== undefined ? value.collectionId : undefined,
    collection_no:
      value.collectionNo !== undefined ? value.collectionNo : undefined,
    reserve_method:
      value.reserveMethod !== '' ? value.reserveMethod : undefined,
    reserve_specify_branch_codes:
      value.reserveSpecifyBranch !== undefined
        ? value.reserveSpecifyBranch.map(item => item.code)
        : undefined,
    specify_collection_id:
      value.specifyCollectionId !== 0 ? value.specifyCollectionId : undefined,
    specify_collection_no:
      value.specifyCollectionNo !== '' ? value.specifyCollectionNo : undefined,
    reserve_registration_branch_code:
      value.reserveRegistrationBranchCode.code !== ''
        ? value.reserveRegistrationBranchCode.code
        : undefined
  }
}
